<div class="zesty-modal__backdrop animated fadeIn">
	<div class="zesty-modal__wrapper">
		<div class="zesty-modal">
			<div class="zesty-modal__header">
				<h3 class="zesty-modal__title">{{ data?.title }}</h3>
			</div>
			<div class="zesty-modal__content">
				<mat-form-field>
					<mat-label>Organization unit</mat-label>
					<mat-select
						[formControl]="orgUnitControl"
						[disabled]="(isLoading$ | async) || isEmpty((orgUnits$ | async)?.OU)"
					>
						<mat-option *ngFor="let orgUnit of (orgUnits$ | async)?.OU | keyvalue" [value]="orgUnit.key">
							{{ orgUnit.value }}
						</mat-option>
					</mat-select>
				</mat-form-field>
				<div class="text-danger" *ngIf="!(isLoading$ | async) && isEmpty((orgUnits$ | async)?.OU)">
					<p>No units available</p>
				</div>
			</div>
			<div class="zesty-modal__actions">
				<button class="zesty-modal__close" (click)="closeEvent()">Close</button>
				<button
					class="zesty-modal__create-btn delete"
					(click)="selectOrgUnit()"
					[disabled]="orgUnitControl.invalid || (isLoading$ | async)"
				>
					Select
				</button>
			</div>
		</div>
	</div>
</div>
